import { t } from '@/plugins/i18n'
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { getArea } from '@/apis/shopcart'
import {
  getClearanceAddressList,
  getShippingAddressList,
  addShipping, addClearance,
  setDefaultClearanceAddress,
  setDefaultShippingAddress
} from '@/apis/address'
import { throughCountryGetExpressApi } from '@/apis/user'
import { getAreaList } from '@/util/useCountry'
import { isKO, isJA, getWarehouseCode } from '@/store'
import { getInternationalAreaTxt, getInternationalCityTxt } from '@/views/inshipping/components/data'
import { COUNTRY } from '@/global'

const getName = (row:any) => {
  if (isJA() && row.nationCode === 'JP') {
    return 'nameJa'
  }
  if (isKO() && row.nationCode === 'KR') {
    return 'nameKr'
  }
  return 'nameEn'
}

export const getAreaTxt = (row: { area: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row?.area)
  return t?.label
}

export const getCityTxt = (row: { area: any; city: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row?.area)
  if (t) {
    const v = t.children?.find((e: { intAreaId: any }) => e.intAreaId === row?.city)
    return v?.label
  } else {
    return ''
  }
}
export default (form: any, wareType?:string) => {
  const store = useStore()
  interface iAddressConfig {
    visible: boolean,
    title: string,
    list: any[],
    columns: any[],
    defaultForm: any
    id: string
  }

  const clearanceAddressConfig: iAddressConfig = reactive({
    visible: false,
    title: t('选择清关地址'),
    list: [],
    columns: [
      {
        align: 'center',
        slotName: 'checked',
        width: '100'
      },
      {
        label: t('姓名'),
        prop: 'receiveName',
        align: 'center'
      },
      {
        label: t('公司名'),
        prop: 'company',
        align: 'center',
        slotName: 'company'
      },
      {
        label: t('会社编号'),
        prop: 'companyCode',
        align: 'center'
      },
      {
        label: t('联系电话'),
        prop: 'phone',
        align: 'center'
      },
      {
        label: t('邮箱'),
        prop: 'email',
        align: 'center',
        slotName: 'email'
      },
      {
        label: t('国/地区'),
        prop: 'countryName',
        align: 'center',
        slotName: 'countryName'
      },
      {
        label: t('都道府县'),
        prop: 'area',
        align: 'center',
        slotName: 'area'
      },
      {
        label: t('市'),
        prop: 'city',
        align: 'center',
        slotName: 'city'
      },
      {
        label: t('区町村-详细地址'),
        prop: 'address',
        align: 'center'
      },
      {
        label: t('邮编'),
        prop: 'postalCode',
        align: 'center',
        slotName: 'postalCode'
      },
      {
        label: t('操作'),
        prop: 'action',
        align: 'center',
        slotName: 'action'
      }
    ],
    defaultForm: {
      receiveName: '',
      companyName: '',
      companyCode: '',
      country: '+81',
      phone: '',
      area: '',
      city: '',
      address: '',
      postalCode: '',
      receiveNameEn: '',
      companyNameEn: '',
      areaEn: '',
      cityEn: '',
      addressEn: '',
      defaultAddress: 0
    },
    id: 'shopClearanceAddressId'
  })
  const showClearanceAddress = computed(() => {
    return clearanceAddressConfig?.list.length > 0
  })
  const selectClearanceAddress = ref()
  const selectClearanceAddressFn = (id: any) => {
    const defaultAddress = clearanceAddressConfig.list?.find((e: any) => e.shopClearanceAddressId === id)
    selectClearanceAddress.value = defaultAddress
    form.declarationAddress = defaultAddress
  }
  const refreshClearanceList = () => {
    getClearanceAddressList({
      exportCountry: wareType ?? 'CN'
    }).then((res: { data: any[] }) => {
      clearanceAddressConfig.list = res.data
      clearanceAddressConfig.list.forEach(async (item:any) => {
        const provinces = await getAreaList({ intAreaId: item.nationId ?? '2279' })
        item.provinceName = getInternationalAreaTxt(item, provinces, getName(item))
        item.cityName = getInternationalCityTxt(item, provinces, getName(item))
      })
      const defaultAddress = clearanceAddressConfig.list?.find((e: { defaultAddress: any }) => !!e.defaultAddress)
      form.declarationAddress = defaultAddress || clearanceAddressConfig.list[0]
      selectClearanceAddress.value = defaultAddress || clearanceAddressConfig.list[0]
    })
  }

  refreshClearanceList()

  const openClearanceAddressVisible = () => {
    clearanceAddressConfig.visible = true
  }

  const showShippingAddress = computed(() => {
    return shippingAddressConfig?.list.length > 0
  })
  getShippingAddressList().then((res: { data: any }) => {
    shippingAddressConfig.list = res.data
  })

  const provinces = ref()
  getArea({ type: 0 }).then((res) => {
    provinces.value = res.data
  })

  const shippingAddressConfig: iAddressConfig = reactive({
    visible: false,
    title: t('选择收货地址'),
    list: [],
    columns: [
      {
        align: 'center',
        slotName: 'checked',
        width: '40'
      },
      {
        label: t('姓名'),
        prop: 'receiveName',
        align: 'center'
      },
      {
        label: t('公司名'),
        prop: 'companyName',
        align: 'center'
      },
      {
        label: t('会社编号'),
        prop: 'companyCode',
        align: 'center'
      },
      {
        label: t('联系电话'),
        prop: 'phone',
        align: 'center'
      },
      {
        label: t('国/地区'),
        prop: 'countryName',
        align: 'center',
        slotName: 'countryName'
      },
      {
        label: t('都道府县'),
        prop: 'area',
        align: 'center',
        slotName: 'area'
      },
      {
        label: t('市'),
        prop: 'city',
        align: 'center',
        slotName: 'city'
      },
      {
        label: t('区町村-详细地址'),
        prop: 'address',
        align: 'center'
      },
      {
        label: t('邮编'),
        prop: 'postalCode',
        align: 'center',
        slotName: 'postalCode'
      }
    ],
    defaultForm: {
      receiveName: '',
      country: '+81',
      phone: '',
      area: '',
      city: '',
      address: '',
      postalCode: '',
      receiveNameEn: '',
      areaEn: '',
      cityEn: '',
      addressEn: '',
      defaultAddress: 0
    },
    id: 'shopShippingAddressId'
  })
  const openShippingAddressVisible = () => {
    shippingAddressConfig.visible = true
  }

  const selectShippingAddress = ref({})
  const selectShippingAddressFn = (id: any) => {
    const defaultAddress = shippingAddressConfig.list?.find((e: any) => e.shopShippingAddressId === id)
    selectShippingAddress.value = defaultAddress
    form.receiverAddress = defaultAddress
    form.receiverEnglishAddress = defaultAddress
    // 切换收货地址要去重新获取物流信息
    getExpressList(selectShippingAddress.value)
  }
  const refreshShippingList = () => {
    getShippingAddressList().then((res: { data: any }) => {
      shippingAddressConfig.list = res.data
      const defaultAddress = shippingAddressConfig.list?.find((e: { defaultAddress: any }) => !!e.defaultAddress)
      form.receiverAddress = defaultAddress || shippingAddressConfig.list[0]
      form.receiverEnglishAddress = defaultAddress || shippingAddressConfig.list[0]
      selectShippingAddress.value = defaultAddress || shippingAddressConfig.list[0]
      getExpressList(selectShippingAddress.value)
      shippingAddressConfig.list.forEach(async (item:any) => {
        const provinces = await getAreaList({ intAreaId: item.nationId ?? '2279' })
        item.provinceName = getInternationalAreaTxt(item, provinces, getName(item))
        item.cityName = getInternationalCityTxt(item, provinces, getName(item))
      })
    })
  }
  refreshShippingList()

  const intShipTypeOption: any = ref([])
  const getExpressList = (address:any) => {
    throughCountryGetExpressApi({
      systemSource: store.getters.plat === 'd2c' ? 1 : 2,
      countryCode: address?.nationCode || 'JP',
      warehouseCode: getWarehouseCode(wareType === COUNTRY.KR)
    }).then(res => {
      intShipTypeOption.value = res.data
      form.intShipConfigId = intShipTypeOption.value.find((e: { intShipConfigId: string }) => e.intShipConfigId === form.intShipConfigId) ? form.intShipConfigId : ''
    })
  }
  const intShipType = computed({
    get: () => form.intShipConfigId,
    set: (v) => {
      console.log('set intShipType')
      const t = intShipTypeOption.value.find((e: { intShipConfigId: string }) => e.intShipConfigId === v)
      form.intShipConfigId = v
      console.log('set intShipType - t', t)
      form.intForwarderConfigId = t.forwarders[0]?.intForwarderConfigId
      form.distribution = t.distribution
      form.forwarder = t.forwarders[0]?.forwarder
      form.shippingType = t.forwarders[0]?.shippingType
    }
  })
  return {
    intShipTypeOption,
    intShipType,
    showClearanceAddress,
    clearanceAddressConfig,
    addClearance,
    setDefaultClearanceAddress,
    openClearanceAddressVisible,
    showShippingAddress,
    shippingAddressConfig,
    addShipping,
    setDefaultShippingAddress,
    openShippingAddressVisible,
    provinces,
    selectShippingAddress,
    selectShippingAddressFn,
    selectClearanceAddress,
    selectClearanceAddressFn,
    refreshClearanceList,
    refreshShippingList
  }
}
